/**
 * Updates the document <link rel="icon"> and <title> to match the
 * current tenant's faviconUrl + name. Falls back to the platform default
 * when no tenant or no favicon is set.
 */
import { useEffect } from "react";
import { useCurrentTenant } from "./useTenant";

const DEFAULT_FAVICON = "/brand/favicon-64.png?v=2";

export function useFavicon() {
  const { data } = useCurrentTenant();
  const tenant = data?.tenant;
  const faviconUrl = tenant && !tenant.isPlatform ? tenant.settings?.branding?.faviconUrl : null;
  const name = tenant && !tenant.isPlatform ? tenant.name : "Wachsen Markets";

  useEffect(() => {
    // <link rel="icon"> — there may be multiple (svg, png, sizes); replace
    // the primary one and remove any siblings so the browser doesn't keep
    // showing the default in some tabs.
    const head = document.head;
    const links = Array.from(head.querySelectorAll<HTMLLinkElement>('link[rel*="icon"]'));
    links.forEach((l, i) => { if (i > 0) l.remove(); });
    let link = links[0];
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      head.appendChild(link);
    }
    link.type = "image/png";
    link.href = faviconUrl || DEFAULT_FAVICON;
  }, [faviconUrl]);

  useEffect(() => {
    document.title = name;
  }, [name]);
}
